import React, {Fragment} from 'react';
import Html from 'slate-html-serializer';
import {defaultTagRules, TagRulesConverter} from "./ComponentFormatters";

const BLOCK_TAGS = {
    blockquote: 'blockquote',
    p: 'paragraph',
    h1: 'header',
    h2: 'header',
    h3: 'header',
    h4: 'header',
    h5: 'header',
    h6: 'header',
    paragraph: 'paragraph',
    body: 'wrapper',
    table: 'table',
    tbody: 'tbody',
    td: 'td',
    tr: 'tr',
    ul: 'ul',
    ol: 'ol',
    li: 'li',
    div: 'wrapper',
    center: 'center',
    style: 'inline-css',
    head: 'wrapper',
    html: 'wrapper'
};

const INLINE_TAGS = {
    pre: 'code',
    img: 'figure',
    a: 'link',
    br: 'break'
};

const MARK_TAGS = {
    i: 'italic',
    b: 'bold',
    u: 'underline'
};

let schema = {
    document: {
        nodes: [{
            match: [{type: 'wrapper'}, {type: 'editor'}, {object: 'text'}]
        }]
    },
    blocks: {
        editor: {
            nodes: [{
                match: [{object: 'block'}, {object: 'inline'}, {object: 'text'}]
            }]
        },
        wrapper: {
            nodes: [{
                match: [{object: 'block'}, {object: 'inline'}, {object: 'text'}]
            }]
        },
        header: {
            nodes: [{
                match: [{object: 'inline'}, {object: 'text'}]
            }]
        },
        paragraph: {
            nodes: [{
                match: [{object: 'inline'}, {object: 'text'}]
            }]
        },
        table: {
            nodes: [{
                match: [{object: 'block'}]
            }]
        },
        tbody: {
            nodes: [{
                match: [{object: 'block'}]
            }]
        },
        tr: {
            nodes: [{
                match: [{object: 'block'}]
            }]
        },
        td: {
            nodes: [{
                match: [{object: 'block'}, {object: 'inline'}, {object: 'text'}]
            }]
        },
        ul: {
            nodes: [{match: {type: 'li'}}]
        },
        ol: {
            nodes: [{match: {type: 'li'}}],
            /*parser: (node) => {
                if (node.nodes) {
                    node.nodes = node.nodes.map((li) => {
                        if (li.type !== 'li') {
                            li = {...li, type: 'li', data: {...li.data, tagname: 'li'}};
                            return li;
                        }
                        return li;
                    });
                }
                return node;
            }*/
            /*normalize: (editor, error) => {
                const { code, child, node } = error;

                switch (code) {
                    case "child_type_invalid": {
                        console.log({ error, child, node });
                        if (child.type !== 'li') {
                            editor.setNodeByKey(child.key, {
                                object: 'block',
                                type: 'li',
                                nodes: child.nodes
                            });
                        }
                        break;
                    }
                    default: {
                        console.log({ error, child, node });
                        break;
                    }
                }
            }*/
        },
        li: {
            nodes: [{match: [{object: 'block'}, {object: 'inline'}, {object: 'text'}]}]
        },
        div: {
            nodes: [{
                match: [{object: 'inline'}, {object: 'text'}]
            }]
        },
        blockquote: {
            nodes: [{
                match: [{object: 'text'}]
            }]
        },
        center: {
            nodes: [{
                match: [{object: 'block'}, {object: 'inline'}, {object: 'text'}]
            }]
        },
        'inline-css': {
            nodes: [{
                match: [{object: 'text'}]
            }]
        }
    },
    inlines: {
        'break': {
            isVoid: true
        }
    }
};

Object.keys(schema).map((key) => {
    if (key === "blocks" || key === "inlines") {
        Object.keys(schema[key]).map((type) => {
            schema[key][type].normalize = schema[key][type].normalize || ((editor, error) => {
                const { code, child, node } = error;
                // https://codesandbox.io/s/xlvw0rmlq4
                // List.js
                console.error("Slate editor error in <" + type + "> tag: " + code);
                console.error({ error, child, node });
            });
        });
    }
});

let rules = [
    {
        deserialize(el, next) {

        },
        serialize(obj, children) {
            if (obj.object === 'inline') {
                let variable = obj.data.get('variable');
                if (variable !== undefined) {
                    const type = obj.data.get('type');
                    if (type === "mustache") {
                        //console.log(children.get(0)[0]);
                        variable = "{{" + children.get(0)[0] + "}}";
                        //console.log(variable);
                    }
                    return <Fragment>{variable}</Fragment>;
                }
            }
        }
    },
    {
        deserialize(el, next) {
            if (el.tagName.toLowerCase() === 'editor') {
                return {
                    object: 'block',
                    type: 'editor',
                    data: {
                        tagname: el.tagName.toLowerCase(),
                    },
                    nodes : next(el.childNodes)
                };
            }
        },
        serialize(obj, children) {
            if (obj.object === 'block') {
                const Tag = obj.data.get('tagname');
                if (Tag === 'editor') {
                    return <Fragment>{children}</Fragment>;
                }
            }
        }
    },
    {
        deserialize(el, next) {
            const type = BLOCK_TAGS[el.tagName.toLowerCase()];
            if(type) {
                const def = {
                    object: 'block',
                    type: type
                };
                let attributes = {};
                for(let key in el.attributes) {
                    let attr = el.attributes[key];
                    if(attr.nodeName && attr.nodeValue) {
                        attributes[attr.nodeName] = attr.nodeValue;
                    }
                }
                const ret = {
                    ...def,
                    data: {
                        tagname: el.tagName.toLowerCase(),
                        attributes
                    }
                };
                if (schema.blocks[type].nodes) {
                    ret.nodes = next(el.childNodes).filter((node) => {
                        return !(node.object === "text" && node.text.trim() === "");
                    });
                } else {
                    ret.isVoid = true;
                }
                if (type === "inline-css") {
                    ret.data.content = el.textContent;
                }
                return ret;
            }
        },
        serialize(obj, children) {
            if (obj.object === 'block') {
                const Tag = obj.data.get('tagname') || "div";
                switch (obj.type) {
                    case 'editor':
                        return children;
                    case 'paragraph':
                        return <p {...obj.data.get('attributes')}>{children}</p>;
                    case 'blockquote':
                        return <blockquote {...obj.data.get('attributes')}>{children}</blockquote>;
                    case 'header':
                    case 'wrapper':
                    case 'head':
                    case 'center':
                        return <Tag {...obj.data.get('attributes')}>{children}</Tag>;
                    case 'inline-css':
                        return <Tag {...obj.data.get('attributes')}>{obj.data.get('content')}</Tag>;
                    case 'table':
                    case 'tbody':
                    case 'td':
                    case 'tr':
                    case 'ol':
                    case 'ul':
                    case 'li':
                    case 'div':
                        const Type = obj.type;
                        return <Type {...obj.data.get('attributes')}>{children}</Type>;
                }
            }
        },
    },{
        deserialize(el, next) {
            const type = INLINE_TAGS[el.tagName.toLowerCase()];
            const def = {
                object: 'inline',
                type: type
            };
            if(type) {
                const ret = {...def};
                if (schema.inlines[type].nodes) {
                    ret.nodes = next(el.childNodes);
                } else {
                    ret.isVoid = true;
                }
                return ret;
            }
        },
        serialize(obj, children) {
            if (obj.object === 'inline') {
                switch (obj.type) {
                    case 'break':
                        return <br/>;
                    case 'code':
                        return (
                            <pre>
                                <code>{children}</code>
                            </pre>
                        );
                }
            }
        },
    },{
        deserialize(el, next) {
            const type = MARK_TAGS[el.tagName.toLowerCase()];
            if (type) {
                return {
                    object: 'mark',
                    type: type,
                    nodes: next(el.childNodes),
                }
            }
        },
        serialize(obj, children) {
            if (obj.object === 'mark') {
                switch (obj.type) {
                    case 'bold':
                        return <b>{children}</b>;
                    case 'italic':
                        return <i>{children}</i>;
                    case 'underline':
                        return <u>{children}</u>;
                }
            }
        }
    },
];

const conf = TagRulesConverter(defaultTagRules, {schema,rules});
schema = conf.schema;
rules = conf.rules;

// My function that parses a string into an XML DOM, throwing an Error if XML parsing fails
const parseXml = (xmlString) => {
    const parser = new DOMParser();
    // attempt to parse the passed-in xml
    const dom = parser.parseFromString(xmlString, 'text/xml');
    const error = isParseError(dom);
    if (error) {
        throw new Error(error);
    }
    return dom;
}

const isParseError = (parsedDocument) => {
    // parser and parsererrorNS could be cached on startup for efficiency
    const parser = new DOMParser(),
        errorneousParse = parser.parseFromString('<', 'text/xml'),
        parsererrorNS = errorneousParse.getElementsByTagName("parsererror")[0].namespaceURI;

    if (parsererrorNS === 'http://www.w3.org/1999/xhtml') {
        // In PhantomJS the parseerror element doesn't seem to have a special namespace, so we are just guessing here :(
        if (parsedDocument.getElementsByTagName("parsererror").length > 0) {
            return parsedDocument.getElementsByTagName("parsererror")[0].textContent;
        }
        return false;
    }

    if (parsedDocument.getElementsByTagNameNS(parsererrorNS, "parsererror").length > 0) {
        return parsedDocument.getElementsByTagNameNS(parsererrorNS, "parsererror")[0].textContent;
    }
    return false;
};

const parseMustacheTextNode = (node) => {
    if (node.object === "text" && node.text.indexOf("{{") !== -1 && node.text.indexOf("}}") !== -1) {
        const splitText = node.text.split(/([\{][\{][^\}]+[\}][\}])/g);
        return splitText.map((s) => {
            if (/{{[^}]+}}/g.test(s)) {
                const variable = s.substring(2, s.length-2);
                return {object: "inline", type: "variable", data: {type: "mustache", variable}, nodes: [{object: "text", text: variable, marks: []}]};
            } else {
                return {object: "text", text: s, marks: []};
            }
        });
    }
    return node;
}

const mustacheNodeParser = (node) => {
    if (node.nodes !== undefined) {
        const nodes = [];
        node.nodes.map((n) => {
            const r = mustacheNodeParser(n);
            if (Array.isArray(r)) {
                nodes.push.apply(nodes, r);
            } else {
                nodes.push(r);
            }
        });
        node.nodes = nodes;
    } else {
        const r = parseMustacheTextNode(node);
        if (Array.isArray(r)) {
            return r;
        }
    }
    return node;
}

const trim = (node) => {
    if (node.nodes !== undefined) {
        const nodes = [];
        node.nodes.map((n) => {
            const r = trim(n);
            if (Array.isArray(r)) {
                nodes.push.apply(nodes, r);
            } else {
                nodes.push(r);
            }
        });
        node.nodes = nodes;
    } else {
        if (node.object === "text") {
            node.text = node.text.trim();
        }
    }
    return node;
}

const mustacheTags = (deserialized) => {
    //console.log(deserialized.document);
    deserialized.document = mustacheNodeParser(deserialized.document);
    //console.log(deserialized.document);
    //console.log(deserialized.document);
    deserialized.document = trim(deserialized.document);
    //console.log(deserialized.document);
    return deserialized;
}

const oParser = (node) => {
    const parsed = (((schema[node.object + "s"] || {})[node.type] || {}).parser || ((node) => node))(node);
    if (parsed.nodes) {
        parsed.nodes = parsed.nodes.map((node) => oParser(node));
    }
    return parsed;
}

const parser = (parsed) => {
    parsed.document = oParser(parsed.document);
    return parsed;
}

const htmlserializer = new Html({rules, defaultBlock: {type: 'paragraph'}, parseHtml: (html) => new DOMParser().parseFromString(html, 'text/xml')});

const importFromHtml = (html) => parser(htmlserializer.deserialize(html, {toJSON: true}));
const importFromMustache = (html) => parser(mustacheTags(htmlserializer.deserialize(html, {toJSON: true})));

const exportToHtml = (value) => {
    //let ret = htmlserializer.serialize(value);
    //ret = ret.substr("<EDITOR>".length, ret.length - "<EDITOR></EDITOR>".length);
    //return ret;
    return htmlserializer.serialize(value);
};

const exportToMustache = (value) => {
    //let ret = htmlserializer.serialize(value);
    //ret = ret.substr("<EDITOR>".length, ret.length - "<EDITOR></EDITOR>".length);
    //return ret;
    return htmlserializer.serialize(value);
};

export {importFromHtml, exportToHtml, importFromMustache, exportToMustache, schema};